import React, { createContext, ReactNode, useContext } from 'react';

interface DevToolsContextType {
  // Minimal context; extended if needed later.
}

const DevToolsContext = createContext<DevToolsContextType | undefined>(undefined);

export function DevToolsProvider({ children }: { children: ReactNode }) {
  const value: DevToolsContextType = {};
  return (
    <DevToolsContext.Provider value={value}>
      {children}
    </DevToolsContext.Provider>
  );
}

export function useDevTools(): DevToolsContextType {
  const context = useContext(DevToolsContext);
  if (context === undefined) {
    throw new Error('useDevTools must be used within a DevToolsProvider');
  }
  return context;
}
